<template>
  <tile class="opc-pbx">
    <foldable v-model="isExpanded" :title="$t('billing.planform.title.zoomphone')">
      <template #head>
        <div class="opc-pbx-head">
          <div class="opc-pbx-head__logo--left">
            <img class="opc-pbx__logo-icon" :src="icon" :alt="$t('billing.planform.title.zoomphone')" />
          </div>
          <div class="opc-pbx-head__logo">
            <div class="opc-pbx__logo opc-pbx__title-wrapper">
              {{ $t('billing.pbx.title') }}
            </div>
            <div class="opc-config__collapse" v-if="!isExpanded" style="margin-top: 4px;">
              <div v-for="selectedPlansLabel in selectedPlansLabelList" :key="selectedPlansLabel">
                {{ selectedPlansLabel }}
              </div>
            </div>
          </div>
          <zm-button v-if="isExpanded" data-testid="checkout-button-231" type="text" @click="showPlanDetailDialog">
            {{ $t('billing.plan_details') }}
          </zm-button>
        </div>
      </template>
      <div class="opc-pbx__main">
        <h2 id="label-title-1" class="opc-pbx__title">{{ $t('billing.pbx.what_calling_plans') }}</h2>
        <div class="opc-pbx__regions">
          <zm-radio-group aria-labelledby="label-title-1" class="opc-tag-radio" name="calling-plans-group" v-model="activeRegionKey" @change='onRadioChange'>
            <zm-radio
              v-for="(region, index) in regions"
              data-testid="checkout-radio-232"
              :key="index"
              :label="region.key"
              :class="showCheckClass(region)"
            >
              <span v-html="getCallingPlanLabel(region)"></span>
            </zm-radio>
            <zm-radio
              v-for="(region, index) in divisions"
              data-testid="checkout-radio-233"
              :key="index"
              :label="region.key"
              :class="showCheckClass(region)"
            >
              <span v-html="getCallingPlanLabel(region)"></span>
            </zm-radio>
            <zm-radio data-testid="checkout-radio-234" v-for="region in regionsGSList" :key="region.key" :label="region.key" :class="showCheckClass(region)">
              <span v-html="getCallingPlanLabel(region)"></span>
            </zm-radio>
          </zm-radio-group>
        </div>
        <zm-banner v-if="totalLimitedPlansCount > maxLimitedPlansCount4EditFlow" class="number-item" type="warning">
          <div v-html="$t('billing.pbx.more_than_numbers', [maxLimitedPlansCount4EditFlow, pbxContactSalesLink])"></div>
        </zm-banner>
        <div :key="activeRegionKey">
          <config-section v-if="isProCA" :show-action="false" :is-single="true">
              <number-list
                ref="callingSelect"
                :data-tracking="dataTrackingCallingPlan"
                :optionList="mapSelectOptions(divisionCallingPlans, boughtPbxBillingCycle)"
                :before-change="beforeChangeCallingPlan"
                :title="$t('billing.pbx.calling_plans')"
                v-model="regionsConfig[activeRegionKey].callings"/>
          </config-section>

          <config-section
            v-else
            :show-head="!!regionsConfig[activeRegionKey].callings.length"
            :show-action="!isDisableAdd2Cart && !testRegionalCallingPlansFull(boughtPbxBillingCycle)"
            style="z-index: 2"
          >
            <template #title>
              <span>{{ $t('billing.pbx.calling_plans') }}</span>
            </template>
            <template #description>
              <span>{{ callingPlansDesc }}</span>
            </template>
            <template #action>
              <zm-button data-testid="checkout-button-235" type="text" @click="addAnotherCallingPlan">
                {{ $t('billing.pbx.add_another_calling_plan') }}
              </zm-button>
            </template>
              <number-select
                v-if="isGS"
                ref="callingSelect"
                :data-tracking="dataTrackingCallingPlan"
                :optionList="mapSelectOptions(globalSelectCallingPlans, boughtPbxBillingCycle)"
                :deletable="callingPlanDeletable"
                :before-change="beforeChangeCallingPlan"
                :title="$t('billing.pbx.calling_plans')"
                v-model="regionsConfig[activeRegionKey].callings"/>
              <number-select
                v-else
                ref="callingSelect"
                :data-tracking="dataTrackingCallingPlan"
                :optionList="mapSelectOptions(regionalCallingPlans, boughtPbxBillingCycle)"
                :deletable="callingPlanDeletable"
                :before-change="beforeChangeCallingPlan"
                :title="$t('billing.pbx.calling_plans')"
                v-model="regionsConfig[activeRegionKey].callings"
              />
          </config-section>
          <config-section
            v-if="canAddAddtionalNumbers"
            :show-head="!!regionsConfig[activeRegionKey].additions.length"
            :show-action="!isDisableAdd2Cart && !testRegionalAdditionalPlansFull(boughtPbxBillingCycle)"
            style="z-index: 1"
          >
            <template #title>
              <span>{{ $t('billing.pbx.additional_numbers') }}</span>
            </template>
            <template #description>
              <span>{{ $t('billing.pbx.additional_numbers_desc') }}</span>
            </template>
            <template #action>
              <zm-tooltip
                placement="top"
                :disabled="regionsConfig[activeRegionKey].additions.length > 0"
                :content="!selectedCallingPlans.length ? $t('billing.pbx.must_have_a_calling_plan') : $t('billing.pbx.add_additional_numbers_tips')"
              >
                <zm-button data-testid="checkout-button-236" :disabled="!selectedCallingPlans.length && !callingPlans.length" type="text" @click="addAdditionalNumbers">
                  {{ $t('billing.pbx.add_additional_numbers') }}
                </zm-button>
              </zm-tooltip>
            </template>
            <number-select
              v-if="isGS"
              ref="tollfreeSelect"
              :data-tracking="dataTrackingNumbers"
              :optionList="mapSelectOptions(globalSelectAdditionalPlans, boughtPbxBillingCycle)"
              :title="$t('billing.pbx.additional_numbers')"
              v-model="regionsConfig[activeRegionKey].additions"
            />
            <number-select
              v-else
              ref="tollfreeSelect"
              :data-tracking="dataTrackingNumbers"
              :optionList="mapSelectOptions(regionalAdditionalPlans, boughtPbxBillingCycle)"
              :title="$t('billing.pbx.additional_numbers')"
              v-model="regionsConfig[activeRegionKey].additions"
            />
          </config-section>
          <!-- banner -->
          <zm-banner class="reason-tips" v-if="licenseTips" type="info">
            <p v-html="licenseTips"></p>
          </zm-banner>
          <ZP0ABJ v-if='isVisible0ABJValidate' />
          <appeal-byoc v-else />
          <appeal-cycle :cycle="i18n_cycle(planBillInfo.billing_cycle)" :payment="planBillInfo.payment" />
        </div>
      </div>
    </foldable>
  </tile>
</template>

<script>
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import AppealByoc from '../component/appeal-byoc.vue';
import AppealCycle from '../component/appeal-cycle.vue';
import ConfigSection from '../component/config-section.vue';
import NumberSelect from '../component/select-number-list.vue';
import NumberList from '../component/number-list.vue';
import icon from '@/assets/plans/logo_pbx.svg';
import mxEdit from './mx-edit';
import {mapGetters, mapState} from 'vuex';
import { computedPbxBasePlans, computedPbxPlans, computedCallingPlans } from '@/common/service/computers/plans/pbx';
import { i18n_cycle } from '@/utils/i18n-shortcuts';
import {
  trackingAddAdditionalNumbers,
  trackingAddAnotherCallingPlan,
  trackingSelectCallingPlan,
  getZPCallingFeesText
} from '@/plans/ZOOM_PHONE/helper/utils';
import getPbxBillingCycle from "../helper/pbx-billing-cycle";
import { BILLING_CYCLE } from '@/common/constants';
import {PBX_GLOBAL, PBX_REGIONS} from '../helper/constants';
import { shoppingCartPlanInitReady } from '@/utils/ready';
import {CURRENCY_COOKIE_KEY} from "@/utils/currency";
import ZP0ABJ from "@/plans/ZOOM_PHONE/component/0ABJ.vue";

export default {
  mixins: [mxEdit],
  components: {
    ZP0ABJ,
    Foldable,
    Tile,
    ConfigSection,
    NumberSelect,
    NumberList,
    AppealByoc,
    AppealCycle,
  },
  data() {
    return {
      icon,
      isExpanded: true,
    };
  },
  computed: {
    ...mapGetters(['boughtPlans', 'getCurrentBasePlanInfo', 'isDisableAdd2Cart']),
    ...mapState({
      japanIP: (state) => state.Common.japanIP,
    }),
    isVisible0ABJValidate() {
      if (this.activeRegionKey === PBX_GLOBAL.GS) {
        // japan currency or japan location
        if (!this.$config('enable0ABJTool')) {
          return false;
        }
        const currency = this.$cookie.get(CURRENCY_COOKIE_KEY);
        if (currency === "JPY" || this.japanIP) {
          return true;
        }
        return false;
      }
      return false;
    },
    planBillInfo() {
      const plan = computedCallingPlans(this.boughtPlans)?.[0] ?? {};
      const basePlan = computedPbxBasePlans(this.boughtPlans)?.[0] ?? {};
      const payment = getZPCallingFeesText(basePlan).title;
      const billingCycle = basePlan.billing_cycle === BILLING_CYCLE.PAY_AS_YOU_GO ? BILLING_CYCLE.MONTHLY : plan.billing_cycle;
      return {
        billing_cycle: billingCycle,
        payment
      }
    },
    boughtPbxBasePlan() {
      const plans = computedPbxBasePlans(this.boughtPlans);
      return plans?.[0];
    },
    boughtPbxPlans() {
      return computedPbxPlans(this.boughtPlans);
    },
    boughtPbxBillingCycle() {
      return getPbxBillingCycle(this.boughtPlans);
    },
    callingPlansDesc() {
      return this.$t(this.regionArea.find(r => r.key === this.activeRegionKey).desc);
    },
    callingPlans() {
      return computedCallingPlans(this.boughtPlans);
    },
    canAddAddtionalNumbers() {
      return this.selectedCallingPlans.some(callingPlan => {
        return this.plancodeMapSubscriptionDisabled[callingPlan.plan_code] !== 'cancelled';
      }) || this.hasBoughtActiveCallingPlan;
    },
    licenseTips() {
      const hasSameQuantity = this.selectedPbxPlans.some((plan) => {
        const bpPlan = this.boughtPlans.find((bp) => bp.plan_code === plan.plan_code && plan.isStandardPrice === false);
        return bpPlan?.cartInfo.selected_number === plan.cartInfo.selected_number;
      });
      if (hasSameQuantity) {
        return this.$t('billing.planform.meeting_license_custom_pricing');
      }
      return '';
    },
    isJapan(){
      return this.activeRegionKey === PBX_REGIONS.JP
    },
    enableGlobal() {
      return  this.$config('enableZoomPhoneGlobalSelect')
    },
  },
  watch: {
    boughtPbxPlans: {
      immediate: true,
      handler(plans) {
        if (!plans.length) return;
        this.fillSelectModel(this.regionsConfig);
        shoppingCartPlanInitReady.solved();
      },
    },
  },
  methods: {
    i18n_cycle,
    onRadioChange(val) {
      trackingSelectCallingPlan(this.getRegionLabelById(val));
    },
    addAnotherCallingPlan() {
      this.$refs.callingSelect.newItem();
      trackingAddAnotherCallingPlan(this.getRegionLabelById(this.activeRegionKey));
    },
    addAdditionalNumbers() {
      this.$refs.tollfreeSelect.newItem();
      trackingAddAdditionalNumbers(this.getRegionLabelById(this.activeRegionKey));
    }
  },
  mounted() {
    window.$this = this
  }
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
.opc-pbx {
  &__logo {
    display: flex;
    align-items: center;
    margin-bottom: 2px;

    &-icon {
      display: block;
      width: auto;
      height: 100%;
    }
  }
  &__title {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
  }
  &__regions {
    margin: 16px 0;
  }
}
</style>
